import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { GreyTag, LightTag } from 'components/Tag'
import { PointCardUserPointSource, PointCardUserPointType } from 'types/pointCard/pointCardUserPoint'

type Props = {
  pointCardUserPoints: PointCardUserPointType[]
  startIndex: number
  endIndex: number
}

const PointCardUserList: FC<Props> = (props) => {
  const { pointCardUserPoints, startIndex, endIndex } = props
  const dispatch = useDispatch()

  const pointCardUserListData = pointCardUserPoints
    .slice(startIndex, endIndex)
    .reduce((prev: { date: string; pointCardUserPoints: PointCardUserPointType[] }[], pointCardUserPoint) => {
      const next = [...prev]
      const date = format(pointCardUserPoint.created_at.toDate(), 'yyyy年M月d日(E)', { locale: ja })
      const index = prev.findIndex((chunk) => chunk.date === date)
      // 同日付のチャンクが存在する場合
      if (index >= 0) {
        next[index].pointCardUserPoints = [...prev[index].pointCardUserPoints, pointCardUserPoint]
      } else {
        next.push({ date, pointCardUserPoints: [pointCardUserPoint] })
      }
      return next
    }, [])

  return (
    <ul className={styles.point_card_user__list}>
      {pointCardUserListData.map((data) => (
        <li key={data.date}>
          <div className={styles.point_card_user__header}>
            <p className={classNames(styles.point_card_user__headline, text.font_bold, text.font_small)}>{data.date}</p>
          </div>
          {data.pointCardUserPoints
            .filter((listData) => pointCardUserPoints.some((pointData) => pointData.user_id === listData.user_id))
            .map((list, index) => (
              <div key={index} className={styles.point_card_user__label}>
                <div className={styles.point_card_user__inner}>
                  <span className={text.font_xxsmall}>{format(list.created_at.toDate(), 'HH:mm')}</span>
                  <div className={styles.point_card_user__container}>
                    <div
                      className={text.font_small}
                      onClick={() => dispatch(push(`/customer/${list.user_id}`))}
                    >{`${list.user_name}さん`}</div>
                    <div className={styles.point_card_user__flex}>
                      <span className={styles.point_card_user__tag}>
                        {list.point_source === 'initial' && (
                          <LightTag color={'yellow'} label={PointCardUserPointSource[list.point_source]} />
                        )}
                        {list.point_source === 'checkout' && (
                          <LightTag color={'green'} label={PointCardUserPointSource[list.point_source]} />
                        )}
                        {list.point_source === 'code' && (
                          <LightTag color={'blue'} label={PointCardUserPointSource[list.point_source]} />
                        )}
                        {list.point_source === 'manual' && (
                          <GreyTag tagName={PointCardUserPointSource[list.point_source]} />
                        )}
                      </span>
                      <p className={classNames(text.font_small, styles.point_card_user__points)}>{list.points}pt</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </li>
      ))}
    </ul>
  )
}

export default PointCardUserList
